import { createPortal } from "react-dom";
import { formatGoalResultText } from "../../../../utils/casinoMyBets";

const SOCCER_BALL = `${import.meta.env.BASE_URL}assets/img/balls/soccer-ball.png`;

/**
 * Goal / Goal 2 video popup (reference: .video-box > iframe + .cricket20ballpopup while casinoData.rdesc != "").
 * VideoBox renders cardsOverlay after .video-box-container, so the popup is portalled into the
 * .video-box (after the iframe) to keep the reference DOM. Positioned by the reference
 * `.goal .cricket20ballpopup` rules.
 */
export default function GoalBallPopup({ rdesc }) {
  if (!rdesc) return null;
  // The page re-renders on every poll, so the .video-box (mounted with the page) is found here.
  const videoBox = document.querySelector(".casino-table.goal .casino-video .video-box");
  const popup = (
    <div className="cricket20ballpopup">
      <img src={SOCCER_BALL} alt="" /> <span>{formatGoalResultText(rdesc)}</span>
    </div>
  );
  return videoBox ? createPortal(popup, videoBox) : popup;
}
